import './ThoughtDrag.sass';
import React, {useEffect, useRef, useLayoutEffect, useState} from 'react';
import apiJSON from "../../../api/apiJSON";
import {gsap} from 'gsap'
import _ from 'lodash'
import {Draggable} from "gsap/Draggable";
import DragManager from "./DragManager";
import {useDispatch, useSelector} from "react-redux";
import {setAudio,setAudioStatus} from "../../../store/actions/course.action";
import EnhancedPopUp from "../../ui/PopUp/EnhancedPopUp";
import StandardButton from "../../ui/Button/StandardButton";
import Page from "../../Page/Page";
import ThoughtDragReview from "./ThoughtDragReview";

const ThoughtDrag = ({data, completed, next}) => {

    gsap.registerPlugin(Draggable);

    const [dragManager, setDragManager] = useState(null);
    const jsonData = apiJSON.get(data);
    const {scenario, dragWidth, dragHeight, dragColumns, dragRows, dropColumns, dropRows, topPadding} = jsonData;
    const [alert, setAlert] = useState(null)
    const [currentState, setCurrentState] = useState("init");
    const audioStatus = useSelector((state) => state.course.audioStatus);
    const dispatch = useDispatch();


    useLayoutEffect(() => {
        setDragManager(new DragManager());
    }, []);

    useEffect(() => {
        if (dragManager) {
            dragManager.initDrags(".thought-drag-drag-tile");
            dragManager.registerDrops(document.querySelectorAll(".thought-drag-drop"));
        }
    }, [dragManager])

    useEffect(() => {
        console.log("   audioStatus: ", audioStatus);
        if (audioStatus === "audioFinished") {
            setCurrentState("review")
            dispatch(setAudio(null))
        }
    }, [audioStatus])

    const finished = () =>{
        completed();
        next();
    }

    const handleSubmit = () => {
        if (checkAllPlaced()) {
            setCurrentState("interstitial")
        } else {
            setAlert(_.find(scenario.alerts, {"id": "incomplete"}));
        }
    }

    const checkAllPlaced = () => {
        let drops = dragManager.getState();
        for (var i = 0; i < drops.length; i++) {
            let d = drops[i];
            if (d.drag === undefined) {
                return false;
            }
        }
        return true;
    }

    const parsePageContent = (content) => {
        content.elements.map((element) => {
            if (element.animations) {
                element.id = _.uniqueId(element.type)
            }
        })
        return content;
    }

    const getSelectedIds = () =>{
        let ids = [];
        _.map(dragManager.getState(),(d,index)=>{ids[index]=d.drag.id})
        return ids;
    }

    const getDragColumns = () => {
        return "repeat(" + dragColumns + ", minmax(0, 1fr))"
    }

    const getDragRows = () => {
        return "repeat(" + dragRows + ", minmax(0, 1fr))"
    }

    const getDropColumns = () => {
        return "repeat(" + dropColumns + ", minmax(0, 1fr))"
    }

    const getDropRows = () => {
        return "repeat(" + dropRows + ", minmax(0, 1fr))"
    }


    return (
        <div className="ThoughtDrag">
            {(currentState === "review") &&
            <ThoughtDragReview choices={scenario.drags} selected={getSelectedIds()} completed={finished}/>
            }
            {(currentState === "interstitial") &&
            <Page content={parsePageContent(scenario.pages[0])}/>
            }
            {alert &&
            <EnhancedPopUp data={alert}
                           onHide={() => {
                               setAlert(null)
                           }}/>}
            {(currentState === "init") &&
            <div className="thought-drag-init-state">
                <div className="thought-drag-header-panel">
                    {
                        scenario.title &&
                        <div className="thought-drag-header-title">
                            {scenario.title}
                        </div>
                    }
                    {
                        scenario.body &&
                        <div className="thought-drag-header-body">
                            {scenario.body}
                        </div>
                    }
                    {
                        scenario.instructions &&
                        <div className="thought-drag-header-instructions">
                            {scenario.instructions}
                        </div>
                    }
                </div>
                <div className="thought-drag-drag-panel">
                    {
                        <div className="thought-drag-grid"
                             style={{
                                 "gridTemplateColumns": getDragColumns(),
                                 "gridTemplateRows": getDragRows()
                             }}>
                            {
                                scenario.drags.map((d, i, index) => (
                                    <div className="thought-drag-drag-tile"
                                         key={"drag" + i}
                                         id={d.id}
                                         style={{
                                             "width": dragWidth,
                                             "height": dragHeight
                                         }}>
                                        <div className="thought-drag-drag-label">
                                            {d.label}
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    }
                </div>
                <div className="thought-drag-drop-panel">
                    <div className="thought-drag-grid"
                         style={{
                             "gridTemplateColumns": getDropColumns(),
                             "gridTemplateRows": getDropRows()
                         }}>
                        {
                            scenario.drops.map((d, i) => (
                                <div className="thought-drag-drop"
                                     id={d.id}
                                     key={"drop" + i}
                                     style={{
                                         "width": dragWidth,
                                         "height": dragHeight
                                     }}>
                                    <div className="thought-drag-drop-label">
                                        {d.label}
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>
                <StandardButton data={"Submit"}
                                callback={handleSubmit}
                                style={{
                                    "position": "absolute",
                                    "bottom": "1rem"
                                }}/>
            </div>}
        </div>
    );
};

export default ThoughtDrag;